import script from "./cnt-plot_situation_frequencies.vue?vue&type=script&lang=ts&setup=true"
export * from "./cnt-plot_situation_frequencies.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__